import { IconShieldCheck } from "@tabler/icons-react";
import { registerSurfaceItem } from "@/lib/surfaces";
import { lazyNamed } from "@/lib/lazyNamed";

/**
 * US-009 — the audit domain contributes the "Compliance" tab to the facility
 * detail page, so `FacilityDetailPage` no longer imports audit code. Registered
 * with NO `access` rule: visibility stays Premium-tier-only (the tier gate lives
 * inside `FacilityComplianceTab`). Lazy `Component` → the compliance bundle only
 * loads when the tab is opened.
 */
registerSurfaceItem("facility-detail-tabs", {
  id: "compliance",
  label: "Compliance",
  icon: IconShieldCheck,
  order: 70,
  Component: lazyNamed(
    () => import("@/components/audit/FacilityComplianceTab"),
    "FacilityComplianceTab",
  ),
});
